/**
 * Synchronous in-flight guard for attendance punches.
 * React state alone cannot block rapid double-taps before the next render.
 */
let punchInFlight = false;

export function isAttendancePunchInFlight(): boolean {
  return punchInFlight;
}

export function beginAttendancePunch(): boolean {
  if (punchInFlight) return false;
  punchInFlight = true;
  return true;
}

export function endAttendancePunch(): void {
  punchInFlight = false;
}

export async function withAttendancePunchLock<T>(
  work: () => Promise<T>,
): Promise<T | undefined> {
  if (!beginAttendancePunch()) return undefined;
  try {
    return await work();
  } finally {
    endAttendancePunch();
  }
}
